module.exports = __webpack_public_path__ + "img/tbank.ed222b49.svg";